/**
 * @format
 * @module lib/financial/stock-reports-plus
 */
import { qsa } from "utils/utils";
import { isSubscribed, isOnDemand, isFinancialToolsTrial } from "lib/identity/api";
import { constructQuery } from "utils/urls";
import { AWS_STOCK_REPORTS_PLUS_PDF } from "lib/amazon-web-services";

/**
 * @method init
 * @description initializes the "Stock Reports +" card and download link
 */
export default function init() {
  if (isSubscribed() || isOnDemand() || isFinancialToolsTrial()) {
    const links = qsa(".js-stock-reports-plus-link");
    links.forEach(link => {
      const query = constructQuery(
        {
          symbol: encodeURIComponent(link.dataset.symbol || ""),
          exchange: encodeURIComponent(link.dataset.exchange || "")
        },
        true
      );
      link.setAttribute("href", AWS_STOCK_REPORTS_PLUS_PDF + "?" + query);
    });
  }
}
